import angular, { IHttpService } from 'angular';
import { Services } from '@Shared.Angular/@types/services';
import { Guid } from '@Shared.Angular/@types/guid';
import ITagGroupDetail from '@Shared.Angular/@types/core/contracts/queryModel/tagGroup/tagGroupDetail';
import { ITagGroupDeleteWarning } from '@Shared.Angular/@types/core/contracts/queryModel/tagGroup/tagGroupDeleteWarning';

export default class TagGroupApiService {
  private tagGroupsApiBaseUri: string;

  constructor(
    private $http: angular.IHttpService,
    private APP_CONFIG: Services.APP_CONFIG
  ) {
    this.tagGroupsApiBaseUri = this.APP_CONFIG.apiBaseUrl + 'taggroups';
  }

  async getAll() {
    const response = await this.$http.get<ITagGroupDetail[]>(
      this.tagGroupsApiBaseUri
    );
    return response.data;
  }

  async getById(id: Guid) {
    const response = await this.$http.get<ITagGroupDetail>(
      `${this.tagGroupsApiBaseUri}/${id}`
    );
    return response.data;
  }

  async getDeleteWarnings(id: Guid) {
    const response = await this.$http.get<ITagGroupDeleteWarning>(
      `${this.tagGroupsApiBaseUri}/${id}/deletewarnings`
    );
    return response.data;
  }

  async delete(id: Guid) {
    await this.$http.delete(`${this.tagGroupsApiBaseUri}/${id}`);
  }

  async save(tagGroup: ITagGroupDetail) {
    await this.$http.put(this.tagGroupsApiBaseUri, tagGroup);
  }
}

angular
  .module('flowingly.services')
  .factory('tagGroupApiService', [
    '$http',
    'APP_CONFIG',
    ($http: IHttpService, APP_CONFIG: Services.APP_CONFIG) =>
      new TagGroupApiService($http, APP_CONFIG)
  ]);

export type TagGroupApiServiceType = InstanceType<typeof TagGroupApiService>;
